module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.6 6.9l-4 4.9-7.9-9.3-3.5 2.7 8.6 10.1-5.3 6.5h23.8l3.2-6.6-14.9-8.3zm11 14h-21l3.9-4.7.6.8 6 3.6-2.4-6.3-1.3-1.5L19 8.4l13.3 7.5-2.7 5z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tool_draw_polygon.svg
// module id = 723
// module chunks = 2